<div class="page">
    <ul class="nav nav-pills nav-fill mt-3 mx-3 d-lg-none nav-justified">
        <li class="nav-item" *ngFor="let tab of tabs">
            <a [routerLinkActive]="'active'" [routerLink]="[tab.url]"
               class="nav-link">{{tab.title}}</a>
        </li>
    </ul>
    <router-outlet></router-outlet>
</div>
